import { memo, useEffect } from 'react';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router';
import useAuth from '@/hooks/useAuth';
import { useEntityConfig } from '@/hooks/useEntityConfig';
import { IB_DESK_EMBED_PATH } from '@/hooks/useIbDeskSection';
import { useNavigateRedirect } from '@/hooks/useNavigateRedirect';
import { crmOriginOf, isEmbedSession } from '@/utils/b2coreEmbed';
import ProtectedLayout from './ProtectedLayout';

const ProtectedRoute = memo(function ProtectedRoute() {
  const { isAuthenticated } = useAuth();
  const config = useEntityConfig();
  const location = useLocation();
  const navigate = useNavigate();
  const { handleNavigateRedirect } = useNavigateRedirect();

  useEffect(() => {
    if (!isAuthenticated) {
      const redirectPath = sessionStorage.getItem('redirectAfterLogin');

      if (redirectPath && redirectPath === 'logout') {
        sessionStorage.removeItem('redirectAfterLogin');

        return;
      }

      sessionStorage.setItem('redirectAfterLogin', location.pathname);
    }
  }, [isAuthenticated, location.pathname]);

  useEffect(() => {
    if (handleNavigateRedirect()) {
      return;
    }
  }, [handleNavigateRedirect]);

  useEffect(() => {
    if (isAuthenticated) {
      const redirectPath = sessionStorage.getItem('redirectAfterLogin');

      if (!redirectPath) return;

      sessionStorage.removeItem('redirectAfterLogin');
      navigate(redirectPath, { replace: true });
    }
  }, [isAuthenticated, navigate]);

  if (isEmbedSession(crmOriginOf(config.VITE_CLIENT_PORTAL_URL))) {
    return <Navigate to={IB_DESK_EMBED_PATH} replace />;
  }

  return isAuthenticated ? (
    <ProtectedLayout>
      <Outlet />
    </ProtectedLayout>
  ) : (
    <Navigate to={{ pathname: '/login', search: location.search }} replace />
  );
});

export default ProtectedRoute;
